<div style="text-align: center; display: inline-flex;" class="txtBlkShadow">





<p *ngIf="lastqmoon" class="MooonDescription">
   <img
    src="../../../calendar/assets/img/lastqmoon.png"
    alt="Last Quarter Moon"
    
    width=5%
    class="miniMoon"
  />  <br> The Last Quarter Moon is on the {{lastqmoon}}</p>
    
<p *ngIf="newMoon" class="MooonDescription">
    <img
    src="../../../calendar/assets/img/newmoon.png"
    alt="New Moon"
    
    width=5%
    class="miniMoon"
  /><br>The New Moon is on the {{newMoon}}</p>
        
        
<p *ngIf="fullMoon" class="MooonDescription">
    <img
    src="../../../calendar/assets/img/fullmoon.png"
   alt="Full Moon"
   
   width=5%
   class="miniMoon"
 /><br>The {{fullMoonName}} is on the {{fullMoon}}</p>

<p *ngIf="fullMoon2" class="MooonDescription">
    <img
    src="../../../calendar/assets/img/fullmoon.png"
   alt="Full Moon"
   
   width=5%
   class="miniMoon"
 /><br>The {{fullMoonName2}} is on the {{fullMoon2}}</p>

<p  *ngIf="firstqmoon" class="MooonDescription">
    <img
    src="../../../calendar/assets/img/firstqmoon.png"
    alt="First Quarter Moon"
    
    width=5%
    class="miniMoon"
  /><br>The First Quarter Moon is on the {{firstqmoon}}</p>

<p *ngIf="firstqmoon2" class="MooonDescription">
    <img
    src="../../../calendar/assets/img/firstqmoon.png"
    alt="First Quarter Moon"
    
    width=5%
    class="miniMoon"
  /><br>Another First Quarter Moon is on the {{firstqmoon2}}</p>


<p *ngIf="lastqmoon2" class="MooonDescription">
    <img
    src="../../../calendar/assets/img/lastqmoon.png"
    alt="Last Quarter Moon"
    
    width=5%
    class="miniMoon"
  /><br> Another Last Quarter Moon is on the {{lastqmoon2}}</p>



<p *ngIf="newMoon2" class="MooonDescription">
    <img
    src="../../../calendar/assets/img/newmoon.png"
    alt="New Moon"
    
    width=5%
    class="miniMoon"
  /><br>Another New Moon is on the {{newMoon2}}</p>
</div>